
//$(document).ready(function('#AddToCart-product-template').removeClass('disabled').removeAttr('disabled').val('Add to Cart');


$(document).ready(function() {
  if( typeof(productOptions ) != "undefined" ){
    for(i=0;i<productOptions.length;i++) {
      $('.single-option-selector:eq('+ i +')')
      .filter(function() {
        return $(this).find('option').length > 1
      })
      .prepend('<option value="">Pick a variant</option>')
      .val('')
      .trigger('change');
    }
  }
});
